export const insuranceDocuments = [
    {
        title : "Uslovi osiguranja" ,
        link : "https://prodaja.lo.co.me/mps_doc/US-mps-21-04-cg.pdf"
    }
];
